import { z } from 'zod';
import { FlowDataSchema } from './flowData.js';
import { FlowDefinitionState } from './flowDefinition.js';
import { FlowTagInputsSchema } from '../flow/tags.js';
/**
 * Body `PATCH /flow-definitions/{id}` accepts. Structural validation only: flow-api additionally
 * checks that the graph's database references resolve, which needs the database.
 */
export const UpdateFlowDefinitionBodySchema = z.strictObject({
    name: z.string().optional(),
    description: z.string().optional(),
    organizationId: z.string().optional(),
    agentId: z.string().optional(),
    data: FlowDataSchema.describe('Replacement block graph.').optional(),
    state: z
        .enum(FlowDefinitionState)
        .describe('Lifecycle state to move the definition to, such as Published.')
        .optional(),
    notes: z.string().optional(),
    documentationMarkdown: z.string().nullish(),
    tags: FlowTagInputsSchema.nullish(),
});
//# sourceMappingURL=updateRequest.js.map